import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { TravellerQuantityComponent } from "./traveller-quantity.component";

@NgModule({
 imports: [
     CommonModule
 ],
 exports: [TravellerQuantityComponent],
 declarations: [TravellerQuantityComponent],
})
export class TravellerQuantityModule { }
